import { Button, message, Radio, Spin } from 'hljd'
import { observer, Provider } from 'mobx-react'
import React, { Component } from 'react'
import ModalBox from './ModalBox'
import Store from './store'
import style from './style.module.less'
import UploadItem from './UploadItem'

const RadioGroup = Radio.Group
@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store(props.mode, props.onSuccess, props.onError)

    const {
      routeParams: { id, seat },
      location: { state }
    } = props
    this.store.editId = id == 'null' || id == null ? '' : id
    this.store.seat = seat
    this.store.showCaseEntry = state && state.showCaseEntry
  }

  componentDidMount() {
    const {
      routeParams: { id }
    } = this.props

    if (id != 'null' && id != null) {
      this.store.init()
    }
  }

  onUploadError = (up, err) => {
    if (err.code === plupload.FILE_SIZE_ERROR) {
      message.warn(`图片大小超过限制，请重新选择`)
    }
  }

  render() {
    const {
      handleSelectResult, // 打开Modal
      handleClipImage, // 裁剪图片
      uploadImage, // 上传图片
      removeImage, // 删除图片
      selectedImageUp, // 图片链接
      selectedImageDown, // 图片链接
      selectedInfoUp, // 跳转数据
      selectedInfoDown, // 跳转数据
      selectedTypeUp, // 跳转类型
      selectedTypeDown, // 跳转类型
      imageType, // 样式类型
      handleChangeImageType, // 切换样式类型
      submit, // 提交信息
      setMealShow, // Modal显示状态
      editLoading, // loading
      goBack, // 返回
      imageSize,
      handleErrorWarning
    } = this.store

    return (
      <Provider mainStore={this.store}>
        <Spin spinning={editLoading}>
          <div className={style.formItem}>
            <label>
              <i>*</i>选择样式
            </label>
            <div className={style.formBox}>
              <RadioGroup value={imageType} onChange={handleChangeImageType}>
                <Radio value={2}>竖版</Radio>
                <Radio value={3}>横版</Radio>
                <Radio value={1}>双图</Radio>
              </RadioGroup>
            </div>
          </div>
          <UploadItem
            axis={'TOP'}
            aspect={imageSize[imageType - 1].aspectTop}
            sizeText={imageSize[imageType - 1].sizeTextTop}
            uploadLink={selectedImageUp}
            onDelete={removeImage}
            onOk={uploadImage}
            onCliped={handleClipImage}
            onChange={handleSelectResult}
            targetResult={selectedInfoUp}
            targetType={selectedTypeUp}
            onError={handleErrorWarning}
            haveContent={0}
          />
          {imageType == 1 && (
            <UploadItem
              axis={'BOTTOM'}
              aspect={imageSize[imageType - 1].aspectBottom}
              sizeText={imageSize[imageType - 1].sizeTextBottom}
              uploadLink={selectedImageDown}
              onDelete={removeImage}
              onOk={uploadImage}
              onCliped={handleClipImage}
              onChange={handleSelectResult}
              targetResult={selectedInfoDown}
              targetType={selectedTypeDown}
              haveContent={0}
            />
          )}

          <div className={style.submitBox}>
            <Button>
              <a onClick={goBack}>取消</a>
            </Button>
            <Button
              onClick={() => {
                submit()
                this.props.changeOtherGuide && this.props.changeOtherGuide(true)
              }}
              type="primary"
            >
              确定
            </Button>
          </div>

          {setMealShow && <ModalBox store={this.store} />}
        </Spin>
      </Provider>
    )
  }
}
